import React, { useEffect, useState } from 'react';
import { NavLink } from "react-router-dom";
import { Dropdown } from 'react-bootstrap';
import { useJwt } from "react-jwt";
import '../../Components/layout/SideBar.css';

const userEmailKey = 'username'; // Assuming this is your key

function AppSidebar({ isOpen }) {
    const [userEmail, setUserEmail] = useState(sessionStorage.getItem('username'));
    const [role, setRole] = useState(sessionStorage.getItem('role'));
    const [userrole, setUserrole] = useState(
        sessionStorage.getItem('userrole')
            ? sessionStorage.getItem('userrole').split(',').map(r => r.trim())
            : []
    );
    const canAccessOrderTracking = userrole.some(r => ['Admin', 'Coordinator', 'Manager'].includes(r));

    // Define sidebar sections with permissions
    const sidebarSections = [
        {
            title: null, // No title for main nav
            visible: true,
            items: [
                {
                    path: "/",
                    label: "Dashboard",
                    visible: true
                },
                {
                    path: "/Catalog",
                    label: "Product Catalog",
                    visible: true
                },
                {
                    path: "/Checkout",
                    label: "Go To Cart",
                    visible: true
                },
                {
                    path: "/ChangePassword",
                    label: "Change Password",
                    visible: true
                }
            ]
        },
        {
            title: "Admin Tools",
            visible: true,
            items: [
                {
                    path: "/OrderTracking",
                    label: "Order Tracking",
                    visible: canAccessOrderTracking
                },
                {
                    path: "/ProductList",
                    label: "Product Manager",
                    visible: role === 'Admin'
                },
                {
                    path: "/SpareManager",
                    label: "Spare Manager",
                    visible: role === 'Admin'
                },
                {
                    path: "/SparePublisher",
                    label: "Spare Publisher",
                    visible: role === 'Admin'
                },
                {
                    path: "/UserList",
                    label: "User Manager",
                    visible: role === 'Admin'
                }
            ]
        },
        {
            title: "Approvals",
            visible: role === 'Admin' || role === 'Manager' || role === 'Auditor' ||
                userrole.some(r => ['Coordinator', 'Manager', 'MD', 'Commercial'].includes(r)),
            items: [
                {
                    path: "/ExpenseApprovalList",
                    label: getReimbursementApprovalLabel(role),
                    visible: role === 'Admin' || role === 'Manager' || role === 'Auditor'
                },
                {
                    path: "/ServiceRequestApprovalList",
                    label: "Service Request Approval",
                    visible: userrole.some(r => ['Coordinator', 'Manager', 'MD', 'Commercial'].includes(r))
                }
            ]
        },
        {
            title: "My Requests",
            visible: true,
            items: [
                {
                    path: "/MyRequest",
                    label: "My Quotation",
                    visible: true
                },
                {
                    path: "/MyExpenseRequest",
                    label: "My Reimbursement",
                    visible: true
                },
                {
                    path: "/MyServiceRequest",
                    label: "My Service Request",
                    visible: true
                }
            ]
        },
        {
            title: "Reports",
            visible: role === 'Admin' || role === 'Manager',
            items: [
                {
                    path: "/ExpenseReport",
                    label: "Reimbursement Report",
                    visible: role === 'Admin' || role === 'Manager'
                },
                {
                    path: "/ServiceRequestReport",
                    label: "Service Request Report",
                    visible: role === 'Admin' || role === 'Manager'
                }
            ]
        }
    ];

    function getReimbursementApprovalLabel(role) {
        const labels = {
            'Admin': 'Reimbursement Manager Approval',
            'Manager': 'Reimbursement Manager Approval',
            'Auditor': 'Reimbursement Auditor Approval'
        };
        return labels[role] || 'Reimbursement Approval';
    }

    const renderSidebarItem = (item) => (
        <li key={item.path}>
            <NavLink to={item.path} end>
                <span className="admin-nav-text">{item.label}</span>
            </NavLink>
        </li>
    );

    const renderSection = (section, sectionIndex) => {
        if (!section.visible) return null;

        const visibleItems = section.items.filter(item => item.visible);
        if (visibleItems.length === 0) return null;

        return (
            <React.Fragment key={sectionIndex}>
                {section.title && (
                    <div className="sidebar-section-title" style={{ backgroundColor: "lightgray", color: "black" }}>
                        {section.title}
                    </div>
                )}
                <ul className={!section.title ? "main-nav" : "section-nav"}>
                    {visibleItems.map(renderSidebarItem)}
                </ul>
            </React.Fragment>
        );
    };

    return (
        <nav id="sidebar-admin-wraper" className={`admin-sidebar ${isOpen ? 'open' : ''}`}>
            <div className="sidebar-header">
                <div className="user-info" style={{ color: '#022279', fontWeight: 'bold', fontSize: 12 }}>
                    {userEmail?.toUpperCase()}
                </div>
                {false && <div className="user-role-badge">
                    {role && <span className="role-badge">{role}</span>}
                </div>}
            </div>

            <div className="admin-nav">
                {sidebarSections.map(renderSection)}
            </div>
        </nav>
    );
}

export default AppSidebar;
